module.exports = __webpack_public_path__ + "static/media/Calibre-LightItalic.1222cf0d.woff";